import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {    
    code: null, // string, optional  //Mã sở trường
    name: { //object, optional // Tên sở trường
        vi: null, // string, optional  // Tên tiếng Việt
        en: null, // string, optional  // Tên tiếng Anh
    },
    index:null //integer, optional // Thứ tự sắp xếp    
};

// validation form
model.validForm = {   

    code: [ValidService.required],     
    name: { //object, optional // Tên sở trường
        vi: [], // string, optional  // Tên tiếng Việt
        en: [], // string, optional  // Tên tiếng Anh
    },
    index:[]
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["index", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            code: "",
            'name.vi': "",
            'name.en': "",
        },
        valid: {
            code: [],
            'name.vi': [],
            'name.en': []              
        },
        operator: {
            'name.vi': ":regex_i:", //:regex:, $vn_text=Viêt nam
            'name.en': ":regex_i:"
        }
    }
  };

export default model;